import React, { useState, useEffect } from 'react';

import { Container, Stack, Typography } from "@mui/material";
import InvoicesToSendTable from './InvoicesToSendTable';
import InvoicesPendingTable from './InvoicesPendingTable';
import InvoicesPayedTable from './InvoicesPayedTable';

import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import DownloadIcon from '@mui/icons-material/Download';
import axiosInstance from '../../api/axiosInstance';



function InvoicesPage() {
    const [accounts, setAccounts] = useState([]);
    const [invoicesToSend, setInvoicesToSend] = useState([]);
    const [invoicesPending, setInvoicesPending] = useState([]);
    const [payedInvoices, setPayedInvoices] = useState([]);
    // const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    // const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    useEffect(() => {
        const fetchAccounts = async () => {
            try {
                const response = await axiosInstance.get('api/accounts/');
                setAccounts(response.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des comptes : ', error)
            }
        };
        fetchAccounts();
    }, []);

    useEffect(() => {
        const fetchInvoicesToSend = async () => {
            try {
                const response = await axiosInstance.get('api/invoicesToSend/');
                setInvoicesToSend(response.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des factures : ', error);
            }
            ;
        }
        fetchInvoicesToSend();
    }, []);

    const handleGenerateInvoices = async () => {
        try {
            const response = await axiosInstance.get(`api/invoices/create/`);
            setInvoicesToSend(response.data)
        } catch (error) {
            console.error("Erreur lors de la génération des factures.", error);
        }
    };

    const handleSendInvoices = async () => {
        try {
            const response = await axiosInstance.post('api/invoices/send/');
            await new Promise((resolve) => setTimeout(resolve, 5000));
            const sentInvoices = response.data?.sent_invoices || [];
            const sent_invoices_ids = response.data['sent_invoices'].map((inv) => inv.id);
            setInvoicesToSend((invoices_list) =>
                invoices_list.filter((invoice) => !sent_invoices_ids.includes(invoice.id))
            );
            setInvoicesPending((invoices_list) => [...invoices_list, ...sentInvoices]);
            console.log(sentInvoices);
            console.log(invoicesPending);
        } catch (error) {
            console.error("Erreur lors l'envoi des factures.", error);
        }
    };

    useEffect(() => {
        const fetchInvoicesPending = async () => {
            try {
                const response = await axiosInstance.get('api/pendingInvoices/');
                setInvoicesPending(response.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des factures : ', error);
            }
            ;
        }
        fetchInvoicesPending();
    }, []);

    const updatePendingInvoices = (payedInvoice_id) => {
        setInvoicesPending((invoices_list) =>
            invoices_list.filter((invoice) => invoice.id !== payedInvoice_id)
        );
    };

    useEffect(() => {
        const fetchInvoicesPayed = async () => {
            try {
                const response = await axiosInstance.get('api/payedInvoices/');
                setPayedInvoices(response.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des factures payées : ', error);
            }
            ;
        }
        fetchInvoicesPayed();
    }, []);


    const updatePayedInvoices = (payedInvoice) => {
        setPayedInvoices((invoices_list) => [...invoices_list, payedInvoice]);
    };

    return (
        <>
            <Typography variant="h4" sx={{ my: 2 }}>Facturation</Typography>
            <Stack direction={'column'} spacing={4}>
                <Typography variant='h6'>À envoyer</Typography>
                <Stack direction="row" spacing={2}>
                    <Button onClick={handleSendInvoices} variant="contained" endIcon={<SendIcon />}>
                        Envoyer les factures
                    </Button></Stack>
                <InvoicesToSendTable accounts={accounts} invoicesToSend={invoicesToSend} handleGenerateInvoices={handleGenerateInvoices} />
                <Typography variant='h6' >En cours</Typography>
                <InvoicesPendingTable accounts={accounts} invoicesPending={invoicesPending} updatePendingInvoices={updatePendingInvoices} updatePayedInvoices={updatePayedInvoices} />
                <Typography variant='h6' >Payées</Typography>
                <InvoicesPayedTable accounts={accounts} payedInvoices={payedInvoices} />
            </Stack>
        </>
    )
}

export default InvoicesPage;